import axios from "axios";
import { BASE_URL } from "./constant";


export const defaultApi = axios.create({
  baseURL: BASE_URL,
});


// defaultApi.interceptors.request.use(
//   config => {
//     const token = window.localStorage.getItem("token");
//     if (token) {
//       config.headers.Authorization = `Bearer ${token}`;
//     }
//     return config;
//   },
//   error => {
//     return Promise.reject(error);
//   }
// );






